import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Postulacion } from '../../interfaces/postulacion';
import { Postulante } from '../../interfaces/postulante';
import { PostulacionesService } from '../../services/postulaciones.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-modal-postulacion',
  templateUrl: './modal-postulacion.component.html',
  styleUrls: ['./modal-postulacion.component.css']
})
export class ModalPostulacionComponent {

  @Input()
  curso_id: number;

  @Input()
  version: number;
  
  public display: boolean = false;
  public loading: boolean = false;
  public response = {};
  public preguntasPostulacion : any[] = [];
  public preguntaCurso: number = null;
  public postulante: Postulante;
  public postulacion: Postulacion;

  constructor(
    private router: Router,
    private postulacionesService: PostulacionesService,
    private sessionService: SessionService
  ) {
    this.postulante = sessionService.getUser();
  }

  toggleDialog() {
      this.display = !this.display;
      
  }

  ngOnChanges(): void {
    this.cargarPreguntasPostulacion(this.curso_id);
    
  }
  
  async cargarPreguntasPostulacion(curso_id: number){
    let preguntas = await this.postulacionesService.obtenerPreguntasPostulacion(curso_id);    
    preguntas.length > 0 ? preguntas.forEach( pregunta => {      
      this.preguntasPostulacion.push({ label: pregunta.DESCRIPCION, value: pregunta.CODIGO })
    }): this.preguntasPostulacion = [] ;

  }

  postular(){
    this.loading = true;    
    let postulacion = <Postulacion>{
      run: this.sessionService.getUser().run,
      curso_id: this.curso_id,
      version: this.version,
      medioDifusion: this.preguntaCurso
    };
    let postulante = <Postulante>this.sessionService.getUser();
    postulante.extranjero = postulante.dv == 'E';
    this.postulacionesService.ingresarPostulacion(postulante, postulacion).then((res: any) => {
      this.response = res;
      this.loading = false;
      if(res.status && res.status !== 'ERROR'){
        this.router.navigate(['/micuenta/postulaciones']);         
      }
      
    });

  }

}
